import axios from 'axios'
import cookie from '@/common/utils/cookie'
import {
  comparePath,
  getDrm,
  getServiceLocationInfo,
  isExplorer,
} from '@/common/utils/common'
import _ from 'lodash'
import fp from 'lodash/fp'
import {
  SERVICE_LOCATION_AMAZON,
  SERVICE_LOCATION_AZURE,
} from '@/common/resources/const'
import { parseUrl, stringify } from 'query-string'
import {
  API_BASE_ANNEX_AZURE_URL,
  API_BASE_ANNEX_URL,
  API_BASE_ANNEXM_AZURE_URL,
  API_BASE_ANNEXM_URL,
  API_BASE_AZURE_URL,
  API_BASE_URL,
  API_BASE_URL_CLOVER_FIELD,
  AWS_WHITE_LIST,
  HTTP_METHOD_DELETE,
  HTTP_METHOD_GET,
  HTTP_METHOD_POST,
  URL_GET_URL_FROM_UI_CODE,
} from '@/common/utils/request.const'
import {
  eventBodyListParser,
  getSectionEventObject,
} from '@/common/utils/gnb.fp'

export const API_KEY = 'E5F3E0D30947AA5440556471321BB6D9'

export const getCommonParam = () => {
  return {
    apikey: API_KEY,
    device: 'pc',
    partner: 'pooq',
    pooqzone: cookie.getPooqZoneType(),
    region: 'kor',
    drm: getDrm(),
    targetage: cookie.getAdultSettings() === 'H' ? '20' : 'all',
    client_version: '6.0.1',
  }
}
export const getCredential = () => {
  return {
    credential: encodeURIComponent(cookie.getCredential()),
  }
}

export const makeRequest = (req) => {
  const requestInfo = {
    url: req.url,
    method: req.method,
    responseType: 'json',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json; charset=utf-8',
    },
  }

  // INFO: Support Azure migration
  const { url } = parseUrl(requestInfo.url)
  const locationInfo = getServiceLocationInfo()
  const locationType = _.get(locationInfo, 'location', SERVICE_LOCATION_AMAZON)
  const isAnnexAPI = url.indexOf(API_BASE_ANNEX_URL) > -1
  const isAnnexmAPI = url.indexOf() > -1
  if (locationType === SERVICE_LOCATION_AZURE) {
    if (isAnnexAPI || isAnnexmAPI) {
      if (isAnnexAPI) {
        requestInfo.url = requestInfo.url.replace(
          API_BASE_ANNEX_URL,
          API_BASE_ANNEX_AZURE_URL,
        )
      } else {
        requestInfo.url = requestInfo.url.replace(
          API_BASE_ANNEXM_URL,
          API_BASE_ANNEXM_AZURE_URL,
        )
      }
    } else {
      const targetUrl = url
        .replace(API_BASE_URL_CLOVER_FIELD, '')
        .replace(API_BASE_URL, '')
      const forceAWS =
        AWS_WHITE_LIST.find((checkPath) => {
          return (
            checkPath.method === requestInfo.method &&
            comparePath(checkPath.path, targetUrl)
          )
        }) !== undefined
      if (!forceAWS) {
        requestInfo.url = requestInfo.url.replace(
          API_BASE_URL,
          API_BASE_AZURE_URL,
        )
      }
    }
  }

  // Support Azure migration end
  if (req.headers) {
    requestInfo.headers = _.assign(requestInfo.headers, req.headers)
  }
  requestInfo.params = getCommonParam()
  const credentialInParameters = _.get(requestInfo, 'params.credential', '')
  if (credentialInParameters === '') {
    const isHaystackDomain = url.indexOf('haystack.wavve.com') > -1
    if (!isHaystackDomain) {
      let credential = cookie.getCredential()
      if (_.get(req, 'url', '').indexOf('credential') > -1) {
        const { query } = parseUrl(_.get(req, 'url', ''))
        credential = query['credential']
      }
      requestInfo.headers = _.assign({}, requestInfo.headers, {
        'wavve-credential': credential,
      })
    }
  }
  requestInfo.paramsSerializer = (params) => {
    return stringify(params, { encode: false })
  }
  if (req.method === HTTP_METHOD_POST || req.method === HTTP_METHOD_DELETE) {
    requestInfo.data = req.data
    requestInfo.transformRequest = (data, headers) => {
      return JSON.stringify(data)
    }
  }
  return requestInfo
}

export const apiRequest = (req) => {
  return axios(makeRequest(req))
}

export const applyQueryString = (url, queryString) =>
  `${url}?${stringify(queryString)}`
export const applyPath = (url, path) => `${url}/${path}`

const isUiEventPath = (url) => url.indexOf('uievent') > -1
export const fetchFromEventObject = (eventData) => {
  const reqObj = {
    url: `https://${_.get(eventData, 'url')}`,
    method: _.get(eventData, 'method', HTTP_METHOD_GET),
  }
  if (
    reqObj.method === HTTP_METHOD_DELETE ||
    reqObj.method === HTTP_METHOD_POST
  ) {
    const parsedEventData = eventBodyListParser(eventData)
    reqObj.data = isUiEventPath(reqObj.url)
      ? { list: [parsedEventData] }
      : parsedEventData
  }
  return apiRequest(reqObj)
}

export const fetchOnContent = (sectionInfo) => {
  const { onContent } = fp.flow(
    fp.getOr([], 'eventlist'),
    getSectionEventObject,
  )(sectionInfo)
  return fetchOnEventObject(onContent)
}

export const fetchOnViewMore = (sectionInfo) => {
  const { onViewMore } = fp.flow(
    fp.getOr([], 'eventlist'),
    getSectionEventObject,
  )(sectionInfo)
  return fetchOnEventObject(onViewMore)
}

export function fetchOnEventObject(onEvent) {
  const requestUrl = _.get(onEvent, 'url')
  const { url, query } = parseUrl(requestUrl)
  const keywordInQuery = _.get(query, 'keyword', '')
  if (isExplorer() && keywordInQuery !== '') {
    query.keyword = decodeURIComponent(query.keyword)
    onEvent.url = url + '?' + stringify(query)
  }
  return fetchFromEventObject(onEvent)
}

export const getUrlFromUiCode = (uiCode) => {
  return apiRequest({
    url: applyPath(URL_GET_URL_FROM_UI_CODE, uiCode),
    method: HTTP_METHOD_GET,
  })
}
